// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"a1cd0d90","419":"28a941a9","563":"96aabb4e","787":"0dc56189","942":"714edabe"}[chunkId] + ".chunk.js";
};